// extracted by mini-css-extract-plugin
export default {"list":"Tools_list__N1FVf","item":"Tools_item__0PfG3","icon":"Tools_icon__ngb1s","selected":"Tools_selected__xLPzs","about":"Tools_about__AAbaT","title":"Tools_title__H8iAf"};